"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flooding = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SelectPlayer_1 = require("../../inputs/SelectPlayer");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const CardName_1 = require("../../CardName");
const Resources_1 = require("../../Resources");
const constants_1 = require("../../constants");
const PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
const TileType_1 = require("../../TileType");
class Flooding extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.FLOODING,
            cost: 7,
            tr: { oceans: 1 },
            metadata: {
                cardNumber: '188',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.oceans(1).nbsp().minus().megacredits(4).any.asterix();
                }),
                description: 'Place an ocean tile. IF THERE ARE TILES ADJACENT TO THIS OCEAN TILE, YOU MAY REMOVE 4 M€ FROM THE OWNER OF ONE OF THOSE TILES.',
                victoryPoints: -1,
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (trGain === 0)
            return true;
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        else {
            return true;
        }
    }
    play(player) {
        if (player.game.isSoloMode()) {
            player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
            return undefined;
        }
        const oceansMaxedBeforePlacement = player.game.noOceansAvailable();
        if (oceansMaxedBeforePlacement === true)
            return undefined;
        return new SelectSpace_1.SelectSpace('Select space for ocean tile', player.game.board.getAvailableSpacesForOcean(player), TileType_1.TileType.OCEAN, (space) => {
            const adjacentPlayers = new Set();
            player.game.addOceanTile(player, space.id);
            player.game.board.getAdjacentSpaces(space).forEach((space) => {
                if (space.player && space.player !== player && space.tile) {
                    adjacentPlayers.add(space.player);
                }
            });
            if (adjacentPlayers.size > 0) {
                return new OrOptions_1.OrOptions(new SelectPlayer_1.SelectPlayer(Array.from(adjacentPlayers), 'Select adjacent player to remove 4 M€ from', 'Remove credits', (selectedPlayer) => {
                    selectedPlayer.deductResource(Resources_1.Resources.MEGACREDITS, 4, { log: true, from: player });
                    return undefined;
                }), new SelectOption_1.SelectOption('Don\'t remove M€ from adjacent player', 'Confirm', () => {
                    return undefined;
                }));
            }
            return undefined;
        });
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, oceansToPlace: 1 });
    }
    getVictoryPoints() {
        return -1;
    }
}
exports.Flooding = Flooding;
//# sourceMappingURL=Flooding.js.map